import { createContext, useCallback, useContext, useEffect, useState } from 'react';

/**
 * Kun/Tun rejimi.
 *
 * Rejim <html data-theme="light|dark"> atributiga yoziladi — ranglar
 * src/assets/css/theme.scss dagi CSS o'zgaruvchilari orqali almashadi.
 * Tanlov localStorage'da saqlanadi. Standart — kun (light).
 */

export const THEME_STORAGE_KEY = 'theme-mode';
export const LIGHT = 'light';
export const DARK = 'dark';

export const ThemeModeContext = createContext({});

export const useThemeMode = () => useContext(ThemeModeContext);

export const readStoredMode = () => {
  try {
    return localStorage.getItem(THEME_STORAGE_KEY) === DARK ? DARK : LIGHT;
  } catch (e) {
    // localStorage yopiq bo'lsa (private rejim) — standart kun
    return LIGHT;
  }
};

export const ThemeModeProvider = ({ children }) => {
  const [mode, setMode] = useState(readStoredMode);

  useEffect(() => {
    document.documentElement.dataset.theme = mode;
    try {
      localStorage.setItem(THEME_STORAGE_KEY, mode);
    } catch (e) {
      // saqlanmasa ham joriy sessiyada ishlayveradi
    }
  }, [mode]);

  const toggleMode = useCallback(
    () => setMode((prev) => (prev === DARK ? LIGHT : DARK)),
    [],
  );

  return (
    <ThemeModeContext.Provider
      value={{ mode, setMode, toggleMode, isDark: mode === DARK }}
    >
      {children}
    </ThemeModeContext.Provider>
  );
};
